import GenerateCrudActions, { ICrudActions } from './helpers/CrudActions'

const actions: ICrudActions = GenerateCrudActions({
  collectionName: 'skus',
  entityName: 'sku'
})

export default actions
